import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="aep-swift" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static var extensionVersion: String
`}</code></pre>
    <Variant platform="aep-objc" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>
    <Variant platform="acp-objc" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      